export enum ColorEnum {
  RED = 'RED',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
  YELLOW = 'YELLOW',
  GRAY = 'GRAY',
}

export enum StatusDetailEnum {
  success = 'success',
  failure = 'failure',
}

export const greenStatuses = new Set([
  StatusDetailEnum.success,
]);

export const redStatuses = new Set([
  StatusDetailEnum.failure,
]);

export enum StatusEnum {
  UNKNOWN = 'UNKNOWN',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

// A mapping from the lastOperationStatus strings returned by the API and the status enum.
export const statusEnumLookup: { [key: string]: StatusEnum } = {
  unknown: StatusEnum.UNKNOWN,
  success: StatusEnum.SUCCESS,
  failure: StatusEnum.FAILURE,
  in_progress: StatusEnum.IN_PROGRESS,
};

export const colorStatusMap = {
  [StatusEnum.UNKNOWN]: ColorEnum.BLACK,
  [StatusEnum.SUCCESS]: ColorEnum.GREEN,
  [StatusEnum.FAILURE]: ColorEnum.RED,
  [StatusEnum.IN_PROGRESS]: ColorEnum.GRAY,
};
